/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions, FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions';
export function FxIdWebFeaturesPlayGameResponseSupportFromJSON(json) {
    return FxIdWebFeaturesPlayGameResponseSupportFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseSupportFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesPlayGameResponseSupportToJSON(json) {
    return FxIdWebFeaturesPlayGameResponseSupportToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseSupportToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameResponseSupport.js.map